import type { InjectionKey } from 'vue';
import type { ChatToolTier } from '@klingerator/shared';

/** Door het chatpaneel aangeboden: een bericht versturen met de huidige context (knop "Uitvoeren"). */
export const CHAT_ASK: InjectionKey<(text: string) => Promise<void>> = Symbol('chatAsk');

/** Nederlandse labels voor de tool-chips in de chat (naam → label + icoon). */
const TOOL_LABELS: Record<string, { label: string; icon: string }> = {
  list_products: { label: 'Producten zoeken', icon: 'diagram-3' },
  get_product: { label: 'Product opvragen', icon: 'box-seam' },
  get_product_tree: { label: 'Productboom opvragen', icon: 'diagram-2' },
  validate_product: { label: 'Product valideren', icon: 'check2-circle' },
  get_sync_history: { label: 'Sync-historie opvragen', icon: 'clock-history' },
  search_unit4_products: { label: 'Unit4-artikelen zoeken', icon: 'search' },
  get_unit4_product: { label: 'Unit4-artikel opvragen', icon: 'cloud-download' },
  get_unit4_composition: { label: 'Unit4-stuklijst opvragen', icon: 'list-nested' },
  find_unit4_used_in: { label: 'Gebruik in Unit4 zoeken', icon: 'arrow-90deg-up' },
  list_templates: { label: 'Sjablonen opvragen', icon: 'copy' },
  check_template: { label: 'Sjabloon controleren', icon: 'clipboard-check' },
  catalog_series: { label: 'Codereeks analyseren', icon: '123' },
  sizing_recommend: { label: 'Actuator-sizing berekenen', icon: 'cpu' },
  get_environment: { label: 'Omgeving opvragen', icon: 'gear' },
  list_review_queue: { label: 'Beoordelingswachtrij opvragen', icon: 'clipboard-check' },
  suggest_actions: { label: 'Aanbevelingen', icon: 'lightbulb' },
  // schrijftools
  update_product: { label: 'Productgegevens wijzigen', icon: 'pencil-square' },
  update_product_lines: { label: 'Regels wijzigen', icon: 'list-check' },
  create_product: { label: 'Nieuw product aanmaken', icon: 'plus-square' },
  submit_review: { label: 'Indienen ter beoordeling', icon: 'send-check' },
  withdraw_review: { label: 'Inzending intrekken', icon: 'arrow-counterclockwise' },
  reject_review: { label: 'Inzending afkeuren', icon: 'x-octagon' },
  refresh_from_unit4: { label: 'Vernieuwen uit Unit4', icon: 'arrow-repeat' },
  push_to_unit4: { label: 'Opslaan in Unit4', icon: 'cloud-upload' },
  archive_product: { label: 'Product archiveren', icon: 'archive' },
  restore_product: { label: 'Product terugzetten', icon: 'arrow-up-square' },
  set_product_root: { label: 'Plaatsing in lijst wijzigen', icon: 'list-ul' },
};

export function toolLabel(name: string): string {
  return TOOL_LABELS[name]?.label ?? name.replace(/_/g, ' ');
}

export function toolIcon(name: string): string {
  return TOOL_LABELS[name]?.icon ?? 'tools';
}

/** Korte badge-tekst voor write/delete-tools (leeg voor leestools). */
export function toolTierLabel(tier: ChatToolTier | undefined): string {
  return tier === 'delete' ? 'verwijdert' : tier === 'write' ? 'wijzigt' : '';
}
